import axios from 'axios';


const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api'
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token_agents');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const PUBLIC_PATHS = ['/', '/login', '/signup', '/privacy', '/refer', '/waiting', '/coming-soon', '/download'];
const isPublicPath = (pathname) => {
  if (!pathname || pathname === '/') return true;
  return PUBLIC_PATHS.some(path => path !== '/' && (pathname === path || pathname.startsWith(path))) || pathname.startsWith('/checkout');
};

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token_agents');
        localStorage.removeItem('agent_id');
        localStorage.removeItem('user_id');
        localStorage.removeItem('sub_user_role');
        if (!isPublicPath(window.location.pathname)) {
          window.location.href = '/';
        }
      } else if (error.response.status === 400) {
        // Handle JWT verification errors that come as 400
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          (typeof error.response.data === 'string' ? error.response.data : '');
        const lowerErr = typeof errorMessage === 'string' ? errorMessage.toLowerCase() : '';
        if (
          lowerErr.includes('jwt') ||
          lowerErr.includes('signature') ||
          lowerErr.includes('token') ||
          lowerErr.includes('malformed')
        ) {
          localStorage.removeItem('token_agents');
          localStorage.removeItem('agent_id');
          localStorage.removeItem('user_id');
          localStorage.removeItem('sub_user_role');
          if (!isPublicPath(window.location.pathname)) {
            window.location.href = '/';
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
